import { ListRepository } from '@/repository/list/ListRepository';
import * as APITypes from '@/API';
import { ExclusionRule, HouselistNew } from '@/API';
import { GraphQLResult } from 'aws-amplify/api';
import * as queries from '@/graphql/queries';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import { FilterDefinition } from '@lambda-layer/models/FilterDefinition/FilterDefinition.ts';
import { FilterSelections } from '@lambda-layer/types/filter.ts';
import { buildCountQuery } from '@lambda-layer/utils/queryUtils';

export class HouseListRepository extends ListRepository<HouselistNew> {
  async search(queryVariables: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: queries.searchHouselistNews,
        variables: queryVariables,
      })
    ).data.searchHouselistNews;
  }

  async count(
    filterDefinitions: FilterDefinition[],
    filterSelections: FilterSelections,
    exclusions?: ExclusionRule[]
  ): Promise<number> {
    const { data } = (await this.client.graphql({
      query: buildCountQuery(
        'searchHouselistNews',
        filterDefinitions,
        filterSelections,
        exclusions || []
      ),
    })) as GraphQLResult<APITypes.SearchHouselistNewsQuery>;
    return data.searchHouselistNews?.total || 0;
  }

  protected async getSearchableAggregateBucketResultItems(
    dbColumn: string,
    filterDefinitions: FilterDefinition[],
    filterSelections: FilterSelections,
    exclusions?: ExclusionRule[]
  ): Promise<{
    buckets: (APITypes.SearchableAggregateBucketResultItem | null)[];
    total: number;
  }> {
    const { data } = (await this.client.graphql({
      query: this.createAggregateQuery(
        dbColumn,
        'searchHouselistNews',
        filterDefinitions,
        filterSelections,
        exclusions || []
      ),
    })) as GraphQLResult<APITypes.SearchHouselistNewsQuery>;

    const total = data?.searchHouselistNews?.total ?? 0;

    const buckets =
      (
        data?.searchHouselistNews?.aggregateItems?.[0]
          ?.result as APITypes.SearchableAggregateBucketResult
      )?.buckets ?? [];

    return { buckets, total };
  }
}
